module.exports = __webpack_public_path__ + "static/media/icon-completed.e931ca58.svg";